module.exports = __webpack_public_path__ + "img/eoi-hero_cn.cbf2571.jpg";